
import PropTypes from 'prop-types';
import React, { useState, useCallback, useEffect } from 'react';

import { Label } from 'twyne-new.ui';

import { ReportDatePicker } from '@/components/reports/header';
import { PureSwitch as Switch } from '@Components/form/Switch';
import { TODAY } from 'components/DateRangeButton';

const propTypes = {
  onChange: PropTypes.func,
  comparison: PropTypes.object,
};

export default function HierarchicalHeader({ onChange, dates: { startDate, endDate }, comparison, suppressCompare = false }) {
  const { startDate: comparisonStartDate, endDate: comparisonEndDate } = comparison || {}

  const [dates, setDates] = useState({})
  const [comparisonDates, setComparisonDates] = useState({})
  const [compare, setCompare] = useState(false)

  useEffect(() => {
    const startDate = TODAY.start
    const endDate = TODAY.end
    setDates({ startDate, endDate })
    onChange({
      startDate: startDate.startOf('day'),
      endDate: endDate.endOf('day'),
    })
  }, [])

  useEffect(() => {
    if (startDate && endDate) {
      setDates({ startDate, endDate })
    }
  }, [startDate, endDate])

  useEffect(() => {
    if (comparisonStartDate && comparisonEndDate) {
      setComparisonDates({
        startDate: comparisonStartDate,
        endDate: comparisonEndDate,
      })
      setCompare(true)
    }
  }, [comparisonStartDate, comparisonEndDate])

  useEffect(() => {
    if (comparison?.compare === undefined) return
    setCompare(comparison.compare)
    setComparisonDates(comparison.compare ? { startDate: comparisonStartDate, endDate: comparisonEndDate } : {})
  }, [comparison?.compare])

  const handleChange = useCallback(searchDates => {
    setDates(searchDates)
    onChange(searchDates)
  }, [onChange])

  const handleComparisonDates = useCallback(({ startDate, endDate }) => {
    const comparisonDates = {
      startDate: startDate?.clone().startOf("day"),
      endDate: endDate?.clone().endOf("day"),
    }
    setComparisonDates(state => ({ ...state, ...comparisonDates }))
    onChange({ comparison: { ...comparisonDates, compare: true } })
  }, [onChange])

  const handleCompare = useCallback(event => {
    const compare = event.target.checked
    const comparison = {}

    if (compare) {
      const { startDate, endDate } = dates
      const difference = endDate.diff(startDate, "days")
      const comparisonEndDate = startDate.clone().subtract(1, "days")
      comparison.endDate = comparisonEndDate.endOf("day")
      comparison.startDate = comparisonEndDate.clone().subtract(difference, "days").startOf("day")
    }

    setCompare(compare)
    setComparisonDates(comparison)
    onChange({ comparison: { compare, ...comparison } })
  }, [onChange, dates])

  return <>
    <ReportDatePicker dates={dates} onChange={handleChange} />
    {compare && <>
      <ReportDatePicker dates={comparisonDates} onChange={handleComparisonDates} />
    </>}
    {comparison && !suppressCompare ? <div className='max-md:hidden flex gap-2 flex-col md:flex-row items-center'>
      <Switch onChange={handleCompare} value={compare} />
      <Label>Compare</Label>
    </div> : null}
  </>
}

HierarchicalHeader.propTypes = propTypes
HierarchicalHeader.defaultProps = {}
